'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var qwest = _interopRequireWildcard(require("qwest"));
var _moment = _interopRequireDefault(require("moment"));
var _Button = _interopRequireDefault(require("@material-ui/core/Button"));
var _getErrorsFromResponse = _interopRequireDefault(require("Components/Forms/Functions/getErrorsFromResponse"));
var _Link = _interopRequireDefault(require("Pure/Link"));
var _Routes = require("Shared/Routes");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
_moment.default.locale('fr');
const {
  app
} = window;
class CompanyAccountDetails extends _react.Component {
  state = {
    loading: false
  };
  componentDidMount() {
    const component = this,
      props = this.props,
      state = this.state;
    component.fetchCompany();
  }
  fetchCompany = () => {
    const component = this,
      props = this.props,
      state = this.state;
    component.setState({
      loading: true
    });
    qwest.post('/company/get-mine').then(function (xhr, response) {
      component.setState({
        loading: false,
        company: response.company
      });
      component.fetchCompanyActivity(response.company?.company_activity);
    }).catch(function (error, xhr, response) {
      console.error(response?.error || response?.raw || error);
      component.setState({
        ...(0, _getErrorsFromResponse.default)({
          response: response
        })
      });
    });
  };
  fetchCompanyActivity = company_activity_id => {
    const component = this,
      props = this.props,
      state = this.state;
    component.setState({
      loading: true
    });
    qwest.post('/company-activity/get-all', {
      id: company_activity_id
    }).then(function (xhr, response) {
      component.setState({
        loading: false,
        company_activity: response.company_activities[0]
      });
    }).catch(function (error, xhr, response) {
      console.error(response?.error || response?.raw || error);
      component.setState({
        ...(0, _getErrorsFromResponse.default)({
          response: response
        })
      });
    });
  };
  logout = () => {
    const component = this,
      props = this.props,
      state = this.state;
    qwest.post('/logout').then(function (xhr, response) {
      // Update user permissions now that user is disconnected
      app.emit({
        event: 'sessionNeedsRefresh',
        source: 'logout'
      });
      app.navigateTo((0, _Routes.URL)('Home', _Routes.front_urls));
    }).catch(function (error, xhr, response) {
      console.error(response?.error || response?.raw || error);
      component.setState({
        ...(0, _getErrorsFromResponse.default)({
          response: response
        })
      });
    });
  };
  render() {
    const component = this,
      props = this.props,
      state = this.state;
    let company = state?.company;
    const user = app?.state?.session?.user;
    let phone_number_parse;
    if (company?.home_phone_number && company?.phone_number) {
      phone_number_parse = company?.home_phone_number + ' / ' + company?.phone_number;
    } else if (company?.home_phone_number) {
      phone_number_parse = company?.home_phone_number;
    } else {
      phone_number_parse = company?.phone_number;
    }
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "c-account"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "c-account_row"
    }, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("h2", {
      className: "c-title c-title--medium"
    }, "Coordonn\xE9es de la personne en charge du recrutement"), /*#__PURE__*/_react.default.createElement("p", {
      className: "c-circle-decoration c-circle-decoration--blue"
    }, "Nom :", ' ', company?.lastname + ' ' + company?.firstname), /*#__PURE__*/_react.default.createElement("p", {
      className: "c-circle-decoration c-circle-decoration--blue"
    }, "Num\xE9ro de t\xE9l\xE9phone :", ' ', phone_number_parse), /*#__PURE__*/_react.default.createElement("p", {
      className: "c-circle-decoration c-circle-decoration--blue"
    }, "Adresse mail :", ' ', company?.login), /*#__PURE__*/_react.default.createElement("p", {
      className: "c-circle-decoration c-circle-decoration--blue"
    }, "Fonction dans l'entreprise :", ' ', company?.profession)), /*#__PURE__*/_react.default.createElement("div", {
      className: "c-account_row c-account_row--actions"
    }, /*#__PURE__*/_react.default.createElement(_Link.default, {
      href: "/modifier-mon-compte-entreprise",
      className: "c-btn u-uppercase"
    }, "Modifier mes coordonn\xE9es"), user.create_jobad === true ? /*#__PURE__*/_react.default.createElement(_Link.default, {
      href: "/creer-une-annonce",
      className: "c-btn"
    }, "Cr\xE9er une annonce") : undefined, /*#__PURE__*/_react.default.createElement(_Button.default, {
      onClick: component.logout,
      className: "c-btn c-btn--red"
    }, "D\xE9connexion"))));
  }
}
exports.default = CompanyAccountDetails;
